import { NewReaderProps } from '@readcloud/data';
import * as React from 'react';
import DocumentViewer from './components/DocumentViewer/DocumentViewer';
import { ConnectedAnnotationSidebar } from './components/Toolbars/ConnectedAnnotationSidebar';
import { ConnectedBookmarkSidebar } from './components/Toolbars/ConnectedBookmarkSiderbar';
import ConnectedBottomToolbar from './components/Toolbars/ConnectedBottomToolbar';
import { ConnectedTOCSidebar } from './components/Toolbars/ConnectedTOCSidebar';
import ConnectedTopToolbar from './components/Toolbars/ConnectedTopToolbar';

import { ConnectedToastGenerator } from './components/Toasts/ConnectedToastGenerator';
import { DocumentWithExtrasProvider } from './context/DocumentWithExtrasProvider';
import TextSelectionProvider from './context/TextSelectionProvider';
import { cx } from '@readcloud/ui';

export * from './types/DOMAnnotations';

// Lazy load heavy components
const LazyConnectedAnnotationSidebar = React.lazy(() =>
  import('./components/Toolbars/ConnectedAnnotationSidebar').then((module) => ({
    default: module.ConnectedAnnotationSidebar,
  }))
);

const LazyConnectedBookmarkSidebar = React.lazy(() =>
  import('./components/Toolbars/ConnectedBookmarkSiderbar').then((module) => ({
    default: module.ConnectedBookmarkSidebar,
  }))
);

const LazyConnectedTOCSidebar = React.lazy(() =>
  import('./components/Toolbars/ConnectedTOCSidebar').then((module) => ({
    default: module.ConnectedTOCSidebar,
  }))
);

export function NewReader(props: NewReaderProps & { className?: string }) {
  const containerRef = React.useRef<HTMLDivElement>();
  return (
    <div className="rc-h-full">
      <DocumentWithExtrasProvider>
        <TextSelectionProvider>
          <div
            className={cx('rc-relative rc-flex rc-flex-col', props.className)}
            ref={containerRef}
          >
            <ConnectedTopToolbar />
            <DocumentViewer
              documentData={props.documentData}
              containerRef={containerRef}
              onGoBack={props.onGoBack}
              onReload={props.onReload}
            />
            <ConnectedBottomToolbar containerRef={containerRef} />
            <React.Suspense fallback={<div></div>}>
              <LazyConnectedAnnotationSidebar />
            </React.Suspense>
            <React.Suspense fallback={<div></div>}>
              <LazyConnectedBookmarkSidebar />
            </React.Suspense>
            <React.Suspense fallback={<div></div>}>
              <LazyConnectedTOCSidebar />
            </React.Suspense>
            <ConnectedToastGenerator />
          </div>
        </TextSelectionProvider>
      </DocumentWithExtrasProvider>
    </div>
  );
}

export default NewReader;
